<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <button-add :pathName="addAccountRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('001014001') !== -1"/>
<!--        <button-add :pathName="addAccountRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('001014001') !== -1"/>-->
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../../components/Button/ButtonAdd'
  import InputSearch from '../../../../components/Input/InputSearch'
  import TableMain from '../../../../components/Table/TableMain'
  import {api} from '../../../api/ConfigManagement'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nSuccess} from '../../../../utils/notice'
  import {bus} from '../../../../utils/bus'
  import ButtonCancel from "../../../../components/Button/ButtonCancel"

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSearch,
      ButtonAdd,
      Breadcrumb},
    name: 'free-code-author',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: 'BOSS看板配置'
        }],
        addAccountRouterName: 'boss-bulletin-board-add',
        addBtnValue: '添加授权人',
        searchPlaceholder: '姓名',
        searchKey: '',
        deleteTipInfo: '是否确认删除该授权人？',
        tableHead: [{
          prop: 'name',
          label: '姓名'
        }, {
          prop: 'phone',
          label: '手机号'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        operationArr: ['delete']
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.post(api.getBossPageAuthorizer, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          searchKey: this.searchKey
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.total = res.data.data.total
              let data = res.data.data.list
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.searchKey = v
        this.getPage()
      },
      // 修改
      goToModifyPage (code) {
        this.$router.push({
          path: `/park_server/free_code_author_modify/${code}`
        })
      },
      // 删除
      deleteLine (code) {
        this.$axios.post(api.deleteBossAuthorizer, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/BossBulletinBoard/BossBulletinBoard.vue